import { Arrival as Line } from '@beyond-js/ui';
import { Arrival } from '@beyond-js/ui/react';
import { usePresence } from '@accounts/session';

/**
 * The way back to the product that sent the person here, as the family's one arrival line (D54):
 * "Opened from {product} · Back to {product}", first in the page region.
 *
 * It renders only a destination the service validated, and nothing at all otherwise: an address that
 * arrived in a link is never shown, never followed and never explained, because the person did not
 * write it and cannot fix it. The validated destination is the exact place the product asked to be
 * returned to, so the line reopens it; it stays for the visit, as the validated answer does.
 */
export function Origin() {
	const { sender, language } = usePresence();
	if (!sender) return null;

	// The family's own copy in the interface language: one frozen set per language, so the line is not
	// rebuilt on every render. The React component carries no set of its own; the DOM class does
	return <Arrival product={sender.name} href={sender.destination} labels={Line.labels[language]} />;
}
